var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpDigitalTransformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2799 24.8527C42.5029 24.8248 42.7078 24.7161 42.8558 24.5471C43.0039 24.3781 43.0847 24.1606 43.0829 23.936V20.0603C43.0847 19.8357 43.0039 19.6182 42.8558 19.4492C42.7078 19.2802 42.5029 19.1715 42.2799 19.1437L38.1531 18.6285C37.7325 16.6072 36.9331 14.6838 35.7973 12.9598L38.3548 9.65982C38.4917 9.48356 38.5596 9.26339 38.5458 9.04062C38.5319 8.81785 38.4373 8.60778 38.2796 8.44982L35.5296 5.69982C35.3717 5.54212 35.1616 5.44748 34.9388 5.43364C34.716 5.4198 34.4959 5.48772 34.3196 5.62465L31.0343 8.20415C29.31 7.06849 27.3867 6.2686 25.3656 5.84648L24.8504 1.72148C24.8226 1.49856 24.7139 1.29363 24.5449 1.1456C24.3759 0.997573 24.1584 0.916751 23.9338 0.918484H20.0581C19.8335 0.916751 19.616 0.997573 19.447 1.1456C19.278 1.29363 19.1693 1.49856 19.1414 1.72148L18.6263 5.84648C16.6077 6.26947 14.6871 7.06934 12.9649 8.20415L9.67412 5.64665C9.49785 5.50972 9.27769 5.4418 9.05492 5.45564C8.83214 5.46948 8.62208 5.56412 8.46412 5.72182L5.71412 8.47182C5.55642 8.62978 5.46178 8.83985 5.44794 9.06262C5.4341 9.28539 5.50202 9.50556 5.63895 9.68182L8.20562 12.9818C7.06978 14.7058 6.27044 16.6292 5.84978 18.6505L1.72295 19.1657C1.50003 19.1935 1.2951 19.3022 1.14707 19.4712C0.999038 19.6402 0.918216 19.8577 0.919949 20.0823V23.9433C0.918216 24.168 0.999038 24.3854 1.14707 24.5544C1.2951 24.7234 1.50003 24.8321 1.72295 24.86L5.84978 25.3752C6.27044 27.3964 7.06978 29.3198 8.20562 31.0438L5.64812 34.3438C5.51118 34.5201 5.44327 34.7402 5.45711 34.963C5.47095 35.1858 5.56559 35.3959 5.72328 35.5538L8.47328 38.3038C8.63124 38.4615 8.84131 38.5562 9.06408 38.57C9.28685 38.5838 9.50702 38.5159 9.68328 38.379L12.9833 35.8215C14.7076 36.9571 16.6308 37.757 18.6519 38.1792L19.1671 42.3042C19.195 42.5271 19.3037 42.732 19.4727 42.88C19.6417 43.0281 19.8591 43.1089 20.0838 43.1072H23.9668C24.1914 43.1089 24.4089 43.0281 24.5779 42.88C24.7469 42.732 24.8556 42.5271 24.8834 42.3042L25.3986 38.1792C27.4197 37.757 29.3429 36.9571 31.0673 35.8215L34.3581 38.379C34.5344 38.5159 34.7545 38.5838 34.9773 38.57C35.2001 38.5562 35.4102 38.4615 35.5681 38.3038L38.3181 35.5538C38.4758 35.3959 38.5704 35.1858 38.5843 34.963C38.5981 34.7402 38.5302 34.5201 38.3933 34.3438L35.8358 31.0438C36.9716 29.3198 37.771 27.3964 38.1916 25.3752L42.2799 24.8527Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0007 33.9185C28.582 33.9185 33.9173 28.5833 33.9173 22.0019C33.9173 15.4205 28.582 10.0852 22.0007 10.0852C15.4193 10.0852 10.084 15.4205 10.084 22.0019C10.084 28.5833 15.4193 33.9185 22.0007 33.9185Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10.0852V19.2519",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 24.752C23.5188 24.752 24.75 23.5207 24.75 22.002C24.75 20.4832 23.5188 19.252 22 19.252C20.4812 19.252 19.25 20.4832 19.25 22.002C19.25 23.5207 20.4812 24.752 22 24.752Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1641 23.7014L31.3709 29.3646",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8357 23.7014L12.6289 29.3646",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpDigitalTransformation);
export default __webpack_public_path__ + "static/media/exp_digital_transformation.fcef2522acec9964feb4c4c33e8dc775.svg";
export { ForwardRef as ReactComponent };